export default "__VITE_ASSET__C5h0ShbY__"